<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">1:1 문의하기</span>
            <span class="txt">센터 admin의 1:1 문의글을 확인하고 작성 할 수 있습니다.</span>
        </div>
        <loading-spinner v-if="isLoading"></loading-spinner>
        <div v-else class="com-table-content">
            <div class="com-btn-area">
                <div class="left-box">
                    <button v-if="careAuth === true" class="com-setting-btn" @click="categoryPop = true"></button>
                </div>
                <div class="right-box">
                    <router-link class="com-btn gray" to="/madmin/qna/list">목록</router-link>
                    <button v-if="id" class="com-btn blue" @click="createQna">수정</button>
                    <button v-else class="com-btn blue" @click="createQna">등록</button>
                </div>
            </div>
            <table class="com-table edit">
                <colgroup>
                    <col style="width: 150px" />
                    <col style="width: auto" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>카테고리</th>
                        <td class="no-padding" colspan="3">
                            <select-form
                                :select-data="['카테고리를 선택하세요.', ...categoryTypeList]"
                                :select-value="['', ...categoryTypeValueList]"
                                :selected-value="categoryId"
                                class="full"
                                @update:set="(val) => (categoryId = val)"
                            ></select-form>
                        </td>
                    </tr>
                    <tr>
                        <th>센터명</th>
                        <td>
                            <input v-model="centerName" class="w100p" maxlength="20" type="text" />
                        </td>
                        <th>담당자</th>
                        <td>
                            <input v-model="staffName" class="w100p" maxlength="10" type="text" />
                        </td>
                    </tr>
                    <tr>
                        <th>이메일</th>
                        <td>
                            <input v-model="staffEmail" class="w100p" maxlength="20" type="text" />
                        </td>
                        <th>담당자 연락처</th>
                        <td>
                            <input
                                v-model="staffTelNo"
                                class="w100p"
                                maxlength="13"
                                type="text"
                                @keyup="autoAddDashPhoneNumber"
                            />
                        </td>
                    </tr>
                    <tr>
                        <th>제목</th>
                        <td colspan="3">
                            <input v-model="title" class="w100p" type="text" />
                        </td>
                    </tr>
                    <tr>
                        <th>내용</th>
                        <td colspan="3">
                            <ckeditor v-model="editorData" :config="editorConfig" :editor="editor"></ckeditor>
                        </td>
                    </tr>
                    <tr>
                        <th>파일 첨부</th>
                        <td class="no-padding" colspan="3">
                            <div class="file-box">
                                <input v-model="fileNameListStr" class="design-input" readonly type="text" />
                                <b-form-file
                                    id="file1"
                                    accept=".jpg, .png, .gif"
                                    plain
                                    @change="handleFile"
                                ></b-form-file>
                                <label for="file1">찾아보기</label>
                                <span>&nbsp;&nbsp;파일은 최대 3개까지 첨부 가능합니다. (파일당 5MB 이하)</span>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <!--            <div class="table-bottom-check">-->
            <!--                <div class="com-check">-->
            <!--                    <input type="checkbox" name="check-1" id="check-1-1">-->
            <!--                    <label for="check-1-1">이 글을 상단에 고정합니다.</label>-->
            <!--                </div>-->
            <!--            </div>-->
            <div class="com-btn-area">
                <div class="right-box">
                    <router-link class="com-btn gray" to="/madmin/qna/list">목록</router-link>
                    <button v-if="id" class="com-btn blue" @click="createQna">수정</button>
                    <button v-else class="com-btn blue" @click="createQna">등록</button>
                </div>
            </div>
        </div>

        <!-- 설정 팝업 -->
        <div v-show="categoryPop" class="layer-pop category-setting">
            <div class="view-content">
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">카테고리 설정</span>
                    <p class="sub-txt">
                        카테고리의 이름을 추가, 수정 및 삭제 할 수 있습니다.
                        <br />
                        카테고리 삭제 시, 이전에 작성된 해당 카테고리의 게시글은 카테고리가 없이 표시됩니다.
                    </p>
                    <loading-spinner v-if="isLoading"></loading-spinner>
                    <div v-else class="del-box">
                        <div class="input-cnt flex-col">
                            <div
                                v-for="(category, index) in categoryList.infos"
                                v-if="category.deleteYn === false"
                                class="line"
                            >
                                <input :key="index" ref="categoryArray" v-model="category.name" type="text" />
                                <button class="com-btn" @click="deleteCategory(category.id, index)">삭제</button>
                            </div>
                        </div>
                        <div class="add-btn-cnt">
                            <div class="line">
                                <button class="com-btn" @click="addCategory">+추가</button>
                            </div>
                            <p class="txt">
                                <span class="imp">*</span>
                                최대 10개까지 추가 가능합니다.
                            </p>
                        </div>
                    </div>

                    <div class="bottom-btn">
                        <button class="com-btn" @click="onCancle">취소</button>
                        <button class="com-btn blue" @click="saveCategory">저장</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import '@ckeditor/ckeditor5-build-classic/build/translations/ko';
import LoadingSpinner from '../../../components/LoadingSpinner';
import { validateEmail, validateSpace, validateTelNo } from '@/assets/js/validation.js';
import ClassicEditor from '@/assets/js/ckeditor/ckeditor.js';
import SimpleUpload from '../../../assets/js/ckeditor/simpleUpload';
import { addDashPhoneNumber } from '../../../assets/js/excelCommon';

export default {
    name: 'qnaEdit',
    components: { LoadingSpinner },
    computed: {
        isCareAdmin() {
            return this.$store.getters['auth/isCareAdmin'];
        },
        isSystemAdmin() {
            return this.$store.getters['auth/isSystemAdmin'];
        },
        cId() {
            return this.$store.getters['auth/cId'];
        },
        staffId() {
            const { getters } = this.$store;
            return getters['auth/staffId'];
        },
    },
    mounted() {
        this.init();
    },
    data() {
        return {
            careAuth: false,
            replyQnaId: this.$route.query.replyQnaId,
            parentQnaDetail: null,
            loginCenterId: '',
            loginCenterStaffId: '',
            isLoading: false,
            id: this.$route.params.id, // id가 있으면 수정
            categoryPop: false,
            categoryList: {
                infos: [],
            },
            categoryTypeList: [],
            categoryTypeValueList: [],
            editor: ClassicEditor,
            editorData: '',
            editorConfig: {
                extraPlugins: [SimpleUpload],
                height: '500px',
                language: 'ko',
                simpleUpload: {
                    uploadUrl: '/admin/api/board/file',
                    headers: {
                        'X-CSRF-TOKEN': 'CSRF-Token',
                    },
                },
            },
            categoryId: '',
            title: null,
            content: null,
            uploadFiles: [], // base64, mimetype, name이 담김. 실제로 서버로 request할 data

            base64data: '', // 업로드 파일 base64 임시 저장
            fetchFileList: [], // 수정화면에서 기존에 첨부되어 있던 파일 목록
            fileNameList: [], // 새로 업로드할 파일 목록을 이름으로만 배열로 관리
            fileNameListStr: '', // fileNameList 배열을 화면에 뿌릴때  ', ' 로 연결하기 위해 만든 순수 String
            deleteFileIds: [], // 삭제되는 첨부파일 fileId 배열

            selectedCategoryId: '',

            centerInfo: {},
            centerName: '',
            staffName: '',
            staffEmail: '',
            staffTelNo: '',
            centerStaffId: '',
            fetchCenterId: '',

            staffInfo: {},
        };
    },
    methods: {
        // 초기화
        async init() {
            if (this.isCareAdmin || this.isSystemAdmin) {
                // 케어 권한 확인
                this.careAuth = true;
            }
            this.loginCenterId = this.cId; // 로그인한 사용자의 centerId
            this.loginCenterStaffId = this.staffId; // 로그인한 staffId
            if (this.careAuth || this.replyQnaId) {
                // 케어 admin일 경우 센터명, 담당자, 이메일, 담당자 연락처를 일단은 임의로 넣어줌
                this.centerName = '핏투데이 케어';
                this.staffName = 'admin';
                this.staffEmail = 'root@root.com';
                this.staffTelNo = '010-0000-0000';
            } else {
                await this.fetchCenterData(this.loginCenterId);
                await this.fetchStaffDetail();
                this.centerName = this.centerInfo.centerName || '';
                this.staffName = this.staffInfo.name || '';
                this.staffEmail = this.staffInfo.email || '';
                this.staffTelNo = addDashPhoneNumber(this.staffInfo.phone) || '';
            }
            await this.fetchCategory();
            if (this.replyQnaId && !this.id) {
                // 케어 admin 신규 답변 작성시
                await this.fetchParentQnaDetail();
            } else if (this.id) {
                // 수정이면 1:1문의하기 상세 가져옴
                await this.fetchQnaDetail();
            }
        },

        // 로그인한 직원 정보 가져오기
        async fetchStaffDetail() {
            try {
                const { data } = await this.sendGetStaffDetail();
                this.staffInfo = data;
            } catch (error) {
                console.log(error);
            }
        },

        // 센터직원 조회
        sendGetStaffDetail() {
            return api.get(`/admin/api/center/${this.loginCenterId}/staff/${this.staffId}`);
        },

        // 카테고리 가져오기
        async fetchCategory() {
            try {
                this.isLoading = true;
                const { data } = await this.getCategoryList();
                data.forEach((category) => {
                    // 받아온 data의 key 값을 필요한 값으로만 재배열
                    const tempCategory = {
                        id: category.b_id,
                        largeType: category.b_l_type_cd,
                        smallType: category.b_s_type_cd,
                        name: category.b_namee,
                        deleteYn: category.b_del_yn,
                    };
                    this.categoryList.infos.push(tempCategory);
                });
                this.categoryList.infos.forEach((category) => {
                    // 카테고리 리스트를 select-form 카테고리 목록에 push
                    this.categoryTypeList.push(category.name);
                    this.categoryTypeValueList.push(String(category.id));
                });
                this.isLoading = false;
            } catch (error) {
                console.log(error);
            }
        },

        // 카테고리 목록 조회 API
        getCategoryList() {
            return api.get('/admin/api/board/category', {
                params: {
                    largeType: 'F', // 케어어드민 : F, 센터어드민 : C
                    smallType: 'I', // 팝업 : P, 게시판 : B, 자주하는질문 : F, 일대일문의 : I, 메뉴얼 : M
                },
            });
        },

        // 1:1문의하기 등록 API
        postQna(data) {
            if (this.loginCenterId) {
                // 로그인 사용자가 센터일 경우
                return api.post(`/admin/api/center/${this.loginCenterId}/board/qna`, data);
            }
            // 로그인 사용자가 케어일 경우
            return api.post(`/admin/api/ft/board/qna`, data);
        },

        // 1:1문의하기 수정 API
        putQna(id, data) {
            if (this.loginCenterId) {
                return api.put(`/admin/api/center/${this.loginCenterId}/board/qna/${id}`, data);
            }
            return api.put(`/admin/api/ft/board/qna/${id}`, data);
        },

        // 등록, 수정 validation
        validateValues() {
            const domEditableElement = document.querySelector('.ck-editor__editable');
            const editorInstance = domEditableElement.ckeditorInstance;
            this.editorData = editorInstance.getData();

            if (this.title === '' || this.title === null) {
                this.$nextTick(function () {
                    this.$refs.refTitle.focus();
                });
                return '제목을 입력하세요.';
            } else if (this.editorData === '' || this.editorData === null) {
                return '내용을 입력하세요.';
            }

            if (this.loginCenterId) {
                // 센터 admin은 센터명, 담당자, 이메일, 담당자 연락처 추가 validation

                if (this.centerName !== '' && this.centerName.length < 2) {
                    return '센터명을 다시 확인해주세요.';
                } else if (this.staffName !== '' && this.staffName.length < 2) {
                    return '담당자를 다시 확인해주세요.';
                }

                if (this.staffEmail !== '' && !validateEmail(this.staffEmail)) {
                    return '이메일 주소를 다시 확인해주세요.';
                } else if (this.staffTelNo !== '' && !validateTelNo(this.staffTelNo.replace(/\-/g, ''))) {
                    return '담당자 연락처를 다시 확인해주세요.';
                }

                if (this.centerName === '' || this.centerName === null) {
                    return '센터명을 입력하세요.';
                } else if (this.staffName === '' || this.staffName === null) {
                    return '담당자를 입력하세요.';
                } else if (this.staffEmail === '' || this.staffEmail === null) {
                    return '이메일을 입력하세요.';
                } else if (this.staffTelNo === '' || this.staffTelNo === null) {
                    return '연락처를 입력하세요.';
                }
            }
        },

        // 1:1문의하기 등록, 수정
        async createQna() {
            const validate = this.validateValues();
            if (validate) {
                alert(validate);
                return;
            }
            const domEditableElement = document.querySelector('.ck-editor__editable');
            const editorInstance = domEditableElement.ckeditorInstance;
            this.editorData = editorInstance.getData();

            this.isLoading = true;
            if (this.id && !this.replyQnaId) {
                // 1:1문의하기 수정
                try {
                    if (this.uploadFiles.length !== 0) {
                        // uploadFiles에 값이 있으면 파일을 수정한것, 기존 파일은 delete 하는것으로 간주
                        this.fetchFileList.forEach((file) => {
                            this.deleteFileIds.push(parseInt(file.fileId));
                        });
                    }
                    const updateData = {
                        categoryId: this.categoryId,
                        title: this.title,
                        content: this.editorData,
                        taskType: this.careAuth ? 'F' : 'C', // 케어 : F, 센터 : C
                        showType: 'C', // 전체 : C, 본인 : -
                        centerStaffId: this.loginCenterStaffId, // 현재 로그인한 StaffId
                        staffName: this.staffName,
                        staffTelNo: this.staffTelNo.replace(/\-/g, ''), // 전화번호 하이픈 제거
                        staffEmail: this.staffEmail,
                        deleteFileIds: this.deleteFileIds,
                        uploadFiles: this.uploadFiles,
                    };

                    const { data } = await this.putQna(this.id, updateData);
                    alert('수정 되었습니다.');
                    this.$router.push({ name: 'qnaList' });
                } catch (error) {
                    alert('수정 실패했습니다.');
                    console.log(error);
                }
            } else if (!this.id && !this.replyQnaId) {
                // 1:1문의하기 등록
                try {
                    const createData = {
                        categoryId: this.categoryId,
                        title: this.title,
                        content: this.editorData,
                        taskType: this.careAuth ? 'F' : 'C', // 케어 : F, 센터 : C
                        showType: 'C', // 전체 : C, 본인 : -
                        centerStaffId: this.loginCenterStaffId, // 현재 로그인한 StaffId
                        staffName: this.staffName,
                        staffTelNo: this.staffTelNo.replace(/\-/g, ''), // 전화번호 하이픈 제거
                        staffEmail: this.staffEmail,
                        deleteFileIds: this.deleteFileIds,
                        uploadFiles: this.uploadFiles,
                    };

                    const { data } = await this.postQna(createData);
                    alert('등록 되었습니다.');
                    this.$router.push({ name: 'qnaList' });
                } catch (error) {
                    alert('등록 실패했습니다.');
                    console.log(error);
                }
            } else if (!this.id && this.replyQnaId) {
                // 1:1문의하기 답변 등록(케어만)
                try {
                    const createData = {
                        categoryId: this.categoryId,
                        title: this.title,
                        content: this.editorData,
                        parentId: parseInt(this.replyQnaId),
                        taskType: 'F', // 케어 admin만 답변 등록
                        showType: 'C', // 전체 : C, 본인 : -
                        centerStaffId: this.loginCenterStaffId, // 현재 로그인한 StaffId
                        staffName: this.staffName,
                        staffTelNo: this.staffTelNo.replace(/\-/g, ''), // 전화번호 하이픈 제거
                        staffEmail: this.staffEmail,
                    };
                    if (this.uploadFiles.length > 0) {
                        createData.uploadFiles = this.uploadFiles;
                    }
                    const { data } = await this.postQna(createData);
                    alert('답변 등록 되었습니다.');
                    this.$router.push({ name: 'qnaList' });
                } catch (error) {
                    console.log(error);
                    alert('답변 등록 중 오류가 발생했습니다.');
                }
            } else if (this.id && this.replyQnaId) {
                // 1:1문의하기 답변 수정(케어만)
                try {
                    if (this.uploadFiles.length !== 0) {
                        // uploadFiles에 값이 있으면 파일을 수정한것, 기존 파일은 delete 하는것으로 간주
                        this.fetchFileList.forEach((file) => {
                            this.deleteFileIds.push(parseInt(file.fileId));
                        });
                    }
                    const updateData = {
                        categoryId: this.categoryId,
                        title: this.title,
                        content: this.editorData,
                        parentId: this.replyQnaId,
                        taskType: 'F', // 케어 admin만 답변 등록
                        showType: 'C', // 전체 : C, 본인 : -
                        centerStaffId: this.loginCenterStaffId, // 현재 로그인한 StaffId
                        staffName: this.staffName,
                        staffTelNo: this.staffTelNo.replace(/\-/g, ''), // 전화번호 하이픈 제거
                        staffEmail: this.staffEmail,
                        deleteFileIds: this.deleteFileIds,
                        uploadFiles: this.uploadFiles,
                    };
                    const { data } = await this.putQna(this.id, updateData);
                    alert('답변 수정 되었습니다.');
                    this.$router.push({ name: 'qnaList' });
                } catch (error) {
                    console.log(error);
                    alert('답변 수정 중 오류가 발생했습니다.');
                }
            }
            this.isLoading = false;
        },

        // 1:1문의하기 상세 첨부 파일 리스트 API
        getQnaDetailFileGroup(fileGroupId) {
            return api.get(`/admin/api/board/file-group/${fileGroupId}`);
        },

        // 케어 admin이 답변 작성시 센터가 작성한 원글 상세 Fetch (본문 내용을 상단에 뿌려주기 위해)
        async fetchParentQnaDetail() {
            const { data } = await this.getQnaDetail(this.replyQnaId);
            if (data.id === data.parentId) {
                // 문의글에 답변이 없는 상태일 경우 최초 답변 작성이므로 id가 같음
                // 질문 내용을 답글 내용 제일 상단에 가져옴
                const dash = '- ';
                this.editorData = data.content;
                this.editorData += '<br>';
                for (let i = 0; i < 100; i++) {
                    this.editorData += dash;
                }
            }
        },

        // 1:1문의하기 상세 Fetch
        async fetchQnaDetail() {
            try {
                this.isLoading = true;
                const { data } = await this.getQnaDetail(this.id);
                this.categoryId = String(data.categoryId === null ? '' : data.categoryId);
                this.title = data.title;
                this.editorData = data.content;
                this.staffName = data.staffName;
                this.staffEmail = data.staffEmail;
                this.staffTelNo = data.staffTelNo
                    .replace(/[^0-9]/g, '')
                    .replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, '$1-$2-$3')
                    .replace('--', '-');

                if (data.centerId) {
                    await this.fetchCenterData(data.centerId); // 센터 정보 Fetch
                }
                if (data.fileGroupId) {
                    // fileGroupId가 있으면 파일 목록 fetch
                    const fileGroupData = await this.getQnaDetailFileGroup(data.fileGroupId);
                    fileGroupData.data.forEach((file) => {
                        this.fileNameList.push(file.name);
                    });
                    this.fileNameListStr = this.fileNameList.join(', ');
                    this.fetchFileList = fileGroupData.data;
                }

                this.isLoading = false;
            } catch (error) {
                console.log(error.response.data);
            }
        },

        // 1:1문의하기 상세 API
        getQnaDetail(id) {
            if (this.loginCenterId) {
                // 로그인 사용자가 센터일 경우 1:1 문의하기 상세
                return api.get(`/admin/api/center/${this.loginCenterId}/board/qna/${id}`);
            }
            // 로그인 사용자가 케어일 경우 1:1 문의하기 상세
            return api.get(`/admin/api/ft/board/qna/${id}`);
        },

        // File 핸들러
        async handleFile(e) {
            try {
                const file = e.target.files[0];
                if (file.size > 5000000) {
                    alert('5MB 이하만 첨부 가능합니다.');
                    return;
                }
                let base64data = await this.readFileAsync(file);
                base64data = base64data.split(',')[1];
                if (base64data === undefined) {
                    alert('비어있는 파일은 첨부할 수 없습니다.');
                    return;
                }
                const fileInfo = {
                    filename: file.name,
                    mimetype: file.type,
                    base64data,
                };

                if (this.id) {
                    if (this.uploadFiles.length === 0) {
                        this.fileNameList = [];
                        this.fileNameList.push(fileInfo.filename);
                        this.fileNameListStr = this.fileNameList.join(', ');
                    } else {
                        this.fileNameList.push(fileInfo.filename);
                        this.fileNameListStr = this.fileNameList.join(', ');
                    }
                } else {
                    this.fileNameList.push(fileInfo.filename);
                    this.fileNameListStr = this.fileNameList.join(', ');
                }
                this.uploadFiles.push(fileInfo);
            } catch (error) {
                console.log(error);
                alert('파일 첨부 중 오류가 발생했습니다.');
            }
        },

        // File reader
        readFileAsync(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => {
                    resolve(reader.result);
                };
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
        },

        // 카테고리 아이템 추가
        addCategory() {
            if (this.categoryList.infos.length > 10) {
                alert('카테고리는 최대 10개까지만 추가 가능합니다.');
                return;
            }
            this.categoryList.infos.push({
                largeType: 'F',
                smallType: 'I',
                name: '',
                deleteYn: false,
            });
        },

        // 카테고리 아이템 삭제
        deleteCategory(categoryId, index) {
            if (categoryId === undefined) {
                this.categoryList.infos.splice(index, 1);
            } else if (categoryId) {
                this.categoryList.infos[index].deleteYn = !this.categoryList.infos[index].deleteYn;
            }
        },

        // 카테고리 저장 API
        postSaveCatetory() {
            return api.post('/admin/api/board/category', this.categoryList);
        },

        // 카테고리 저장
        async saveCategory() {
            const validate = this.validateCategoryValues();
            if (!validate.result) {
                alert(validate.msg);
                this.$nextTick(function () {
                    this.$refs.categoryArray[validate.resultIndex].focus();
                });
                return;
            }
            try {
                const { data } = await this.postSaveCatetory();
                alert('카테고리를 저장했습니다.');
                this.initCategoryValue();
                await this.fetchCategory();
            } catch (error) {
                alert('카테고리 저장 실패했습니다.');
                console.log(error);
            }
        },

        // 카테고리 validation
        validateCategoryValues() {
            const msg = '카테고리명을 다시 확인하세요.';
            let result = true;
            let resultIndex = '';
            this.$refs.categoryArray.some((category, index) => {
                if (!validateSpace(category.value) || category.value.length < 2) {
                    result = false;
                    resultIndex = index;
                    return true;
                }
            });
            return { result, resultIndex, msg };
        },

        // 취소 버튼 클릭 이벤트
        onCancle() {
            this.initCategoryValue();
            this.fetchCategory();
            this.categoryId = this.selectedCategoryId;
        },

        // 카테고리 저장전 관련 변수 초기화
        initCategoryValue() {
            this.categoryPop = false;
            this.categoryList = { infos: [] };
            this.categoryTypeList = [];
            this.categoryTypeValueList = [];
            this.selectedCategoryId = this.categoryId; // 이전에 선택했던 카테고리 임시 저장
        },

        // a 태그 파일 다운로드 이벤트
        fileDownload(url) {
            api.post(url, {
                responseType: 'blob',
            })
                .then((response) => {
                    const blob = new Blob([response.data], { type: 'image/png' });

                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    const filename = replaceAll(decodeURI(response.headers.filename), '+', ' ');
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        // 전화번호 입력시 자동 하이픈
        autoAddDashPhoneNumber(e) {
            const inputVal = e.target.value;
            this.staffTelNo = inputVal
                .replace(/[^0-9]/g, '')
                .replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, '$1-$2-$3')
                .replace('--', '-');
        },

        // centerId로 센터 조회
        async fetchCenterData(centerId) {
            try {
                const { data } = await this.getCenterData(centerId);
                this.centerName = data.centerName;
                this.centerInfo = data;
            } catch (error) {
                console.log(error);
            }
        },

        // center 조회 API
        getCenterData(centerId) {
            return api.get(`/admin/api/center/${centerId}`);
        },
    },
};
</script>
<style lang="scss"></style>
